import React from 'react';
import { Accordion } from './ui/Accordion';
export function FAQSection() {
  const faqs = [{
    title: '¿La comida dura hasta el viernes?',
    content: 'Sí, el método incluye técnicas de conservación para módulos específicos. Aprenderás exactamente cómo almacenar cada ingrediente para que se mantenga fresco y seguro toda la semana.'
  }, {
    title: '¿Necesito herramientas caras?',
    content: 'No, basta con tus ollas de siempre y recipientes con tapa. El método está diseñado para funcionar en cualquier cocina estándar sin necesidad de electrodomésticos especiales.'
  }, {
    title: '¿Es comida de dieta?',
    content: 'Es comida real. Tú eliges los ingredientes, el método te da la estructura. Puedes adaptarlo a cualquier estilo de alimentación (vegetariano, sin gluten, bajo en carbohidratos, etc).'
  }, {
    title: '¿Sirve para familias grandes?',
    content: 'Absolutamente, el sistema es escalable según la cantidad de proteína que prepares. Las proporciones modulares te permiten cocinar para 2 o para 6 personas con el mismo esfuerzo de planificación.'
  }];
  return <section className="py-16 px-4 sm:px-6 bg-white" data-id="element-1">
      <div className="max-w-3xl mx-auto" data-id="element-2">
        <div className="text-center mb-10" data-id="element-3">
          <h2 className="text-3xl md:text-4xl font-bold text-brand-text mb-4" data-id="element-4">
            Preguntas Frecuentes
          </h2>
        </div>
        <Accordion items={faqs} data-id="element-5" />
      </div>
    </section>;
}